

const NotFound = () => {
    return (
        <p>!Ops, We cant find what you looking for</p>
    )
}

export default NotFound